import type { ReactiveFlags } from 'vue';
type RawType = object & {
  [ReactiveFlags.SKIP]?: boolean;
};
export const isRaw = <T extends RawType>(rawData: T) => Boolean(rawData?.__v_skip);
